import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Entity } from '../../objects/entity';
// import { GlobalDataService } from '../../global-data.service';
// import { ContractManagerService } from '../../service/contract-manager.service';
import { WorkflowService } from '../../service/workflow.service';
import { QuestionGroup } from '../../objects/interface-library';
import { DocumentReview } from '../../objects/doc-review';
import { Vendor } from '../../objects/vendor';
import { PartyService } from '../../service/entity-services/party.service';

@Component({
    selector: 'app-workflow-questions',
    templateUrl: './workflow-questions.component.html',
    styleUrls: ['./workflow-questions.component.css'],
    standalone: false
})
export class WorkflowQuestionsComponent extends Entity implements OnInit {

  questionsArray: any;
  answerTypesArray: any;

  questionsAnswersObject = {};

  previousAnswers = null;

  constructor(private workflowService: WorkflowService,
              private dialogRef: MatDialogRef<WorkflowQuestionsComponent>,
              @Inject(MAT_DIALOG_DATA) data) { 

    super();

    if (data && data.previousAnswers) {
      console.log('*** Data passed to workflow questions: ', data);
      this.previousAnswers = data.previousAnswers;
    }

  }

  async ngOnInit() {

    // if (!this.globalDataService.currentDocumentReview) {
    //       this.globalDataService.currentDocumentReview = new DocumentReview();
    // }

    // // BUGBUG:  This should be a switch statement but don't need it for the demo
    // let googleSheetQuestionsResponse = await this.workflowService.getStaticSheetQuestions(QuestionGroup.PhysicianEmploymentAgreement);
    // console.log('*** data for questions: ', googleSheetQuestionsResponse);

    // this.questionsArray = googleSheetQuestionsResponse.questions;
    // this.answerTypesArray = googleSheetQuestionsResponse.answerTypes;

    // this.questionsArray.forEach(element => {
    //   console.log('*** Processing element: ', element);
    //   if (this.previousAnswers && this.previousAnswers[element]) {
    //     console.log('*** previous answers: ', this.previousAnswers[element]);
    //     this.questionsAnswersObject[element] = this.previousAnswers[element];
    //   } else {
    //     this.questionsAnswersObject[element] = null;
    //   }
    // });

    // console.log('*** questionsAnswersObject: ', this.questionsAnswersObject);

  }

  async onSubmit() {

    // USERS
// [(ngModel)]="globalDataService.currentDocumentReview.requestor"
// [(ngModel)]="globalDataService.currentDocumentReview.executiveSponsor"

    // if (this.questionsAnswersObject[this.questionsArray[4]]) {

    //   let drAsNewParty = new Vendor();

    //   let datetimestamp = (new Date).getTime().toString();

    //   drAsNewParty.vendorNum = datetimestamp;

    //   console.log('!!!*** questions array: ', this.questionsArray);

    //   drAsNewParty.name = this.questionsAnswersObject[this.questionsArray[4]];

    //   this.questionsAnswersObject[this.questionsArray[6]] ?
    //     drAsNewParty.address = this.questionsAnswersObject[this.questionsArray[6]] :
    //     null;

    //   this.questionsAnswersObject[this.questionsArray[7]] ?
    //     drAsNewParty.secondaryAddress = this.questionsAnswersObject[this.questionsArray[7]] :
    //     null;
        
    //   this.questionsAnswersObject[this.questionsArray[8]] ?
    //     drAsNewParty.city = this.questionsAnswersObject[this.questionsArray[8]] :
    //     null;

    //   this.questionsAnswersObject[this.questionsArray[9]] ?
    //     drAsNewParty.state = this.questionsAnswersObject[this.questionsArray[9]] :
    //     null;

    //   this.questionsAnswersObject[this.questionsArray[10]] ?
    //     drAsNewParty.zip = this.questionsAnswersObject[this.questionsArray[10]] :
    //     null;

    //   this.questionsAnswersObject[this.questionsArray[11]] ?
    //     drAsNewParty.email = this.questionsAnswersObject[this.questionsArray[11]] :
    //     null;

    //   this.questionsAnswersObject[this.questionsArray[12]] ?
    //     drAsNewParty.phonePrimary = this.questionsAnswersObject[this.questionsArray[12]] :
    //     null;

    //   console.log('*** about to create this party: ', drAsNewParty);

    //   await this.contractManagerService.writeParty(drAsNewParty);
  
    //   this.globalDataService.allParties = await this.partyService.getAllParties();

    //   this.globalDataService.currentDocumentReview.party = drAsNewParty;
    // }


    // let physicianEmploymentAgreement = {
    //   internalOrFamily: null,
    //   commencementDate: null,
    //   baseSalary: null,
    //   signingBonus: null,
    //   forgivableLoan: null,
    //   term: null,
    //   maxComp: null
    // }

    // if (this.questionsAnswersObject[this.questionsArray[16]]) {
    //   physicianEmploymentAgreement.term = this.questionsAnswersObject[this.questionsArray[16]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[17]]) {
    //   physicianEmploymentAgreement.internalOrFamily = this.questionsAnswersObject[this.questionsArray[17]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[18]]) {
    //   physicianEmploymentAgreement.commencementDate = this.questionsAnswersObject[this.questionsArray[18]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[19]]) {
    //   physicianEmploymentAgreement.baseSalary = this.questionsAnswersObject[this.questionsArray[19]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[20]]) {
    //   physicianEmploymentAgreement.signingBonus = this.questionsAnswersObject[this.questionsArray[20]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[21]]) {
    //   physicianEmploymentAgreement.forgivableLoan = this.questionsAnswersObject[this.questionsArray[21]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[22]]) {
    //   physicianEmploymentAgreement.maxComp = this.questionsAnswersObject[this.questionsArray[22]];
    // }


    // if (this.questionsAnswersObject[this.questionsArray[0]]) {
    //   this.globalDataService.currentDocumentReview.requestor = this.questionsAnswersObject[this.questionsArray[0]];
    // }

    // if (this.questionsAnswersObject[this.questionsArray[16]]) {
    //   this.globalDataService.currentDocumentReview.term = this.questionsAnswersObject[this.questionsArray[16]];
    // }

    // this.globalDataService.currentDocumentReview.physicianEmploymentAgreement = physicianEmploymentAgreement;

    // console.log('*** workflow-questions | answers object: ', this.questionsAnswersObject);

    // this.dialogRef.close(this.questionsAnswersObject);

  }

  cancelSubmit() {
    this.dialogRef.close(null);
  }  

}
